import { OpenAPI } from '@/repositories/generated/core/OpenAPI';

/**
 * モック用のURL作成
 * @param path APIのパス（Base pathを含まない）
 * @returns APIのエンドポイント
 */
export const createMockEndpoint = (path: string) => {
  const endpoint = `${OpenAPI.BASE}${path}`;
  return endpoint;
};
